module.exports = __webpack_public_path__ + "img/visa.647cca93.svg";